<template>
  <div class="hello" :style="{backgroundImage: 'url(' + loginImg + ')' }">
    <div class="login_box">
      <div class="left">
        <div class="out_img_box">
          <img src="@/assets/login_left.png" class="left_img" alt="" srcset="">
        </div>
      </div>
      <div class="right_box">
        <div class="right_top">
          <!-- <img class="bh_icon" src="https://bhres.39bh.com/site/20220114/0531959fc572fe5d5df1cec0fe587981.png" alt=""
            srcset=""> -->
          <div class="bh_name">推广游戏合作平台</div>
          <div class="login_type_box" v-if="logType == 'account'">
            <div class="put_box">
              <i class="el-icon-user icon"></i>
              <el-input v-model="account.account" @keyup.enter.native="login" style="border: none;"
                placeholder="请输入账号"></el-input>
            </div>
            <div class="put_box">
              <i class="el-icon-lock icon"></i>
              <el-input v-model="account.pwd" @keyup.enter.native="login" :type="hidePwd?'password':'text'"
                style="border: none;" placeholder="请输入密码">
                <div slot="suffix" class="pwd_eye_box" @click="hidePwd=!hidePwd">
                  <i style="font-size: 20px;" v-show="!hidePwd" class="el-input__icon el-icon-view"></i>
                  <img src="@/assets/index/eye-off.png" v-show="hidePwd" alt="" srcset="">
                </div>
              </el-input>
            </div>
            <div class="rember_box">
              <el-checkbox-group v-model="checkList" @change="changeRember">
                <el-checkbox label="记住密码"></el-checkbox>
              </el-checkbox-group>
              <div class="register" @click="openRegister">没有账号?去注册</div>
            </div>
          </div>
          <div class="login_type_box" v-if="logType == 'phone'">
            <div class="put_box">
              <i class="el-icon-mobile-phone icon"></i>
              <el-input v-model="phone.phone" style="border: none;" @keyup.enter.native="login"
                placeholder="请输入手机号"></el-input>
            </div>
            <div class="put_box">
              <i class="el-icon-folder-checked icon"></i>
              <el-input v-model="phone.code" style="border: none;" @keyup.enter.native="login"
                placeholder="请输入验证码"></el-input>
              <div @click="getCode" :class="['code_box', sendOk ? 'send_ok' : '']">
                {{ text }}
              </div>
            </div>
          </div>
        </div>
        <div>
          <!-- <div class="btn" @click="login">登录</div> -->
          <el-button type="primary" style="width: 100%;height: 40px;" :round="true" size="medium" @click="login"
            :loading="btnLoading">登录</el-button>
          <div class="login_type">
            <div class="item" @click="changeLogin(item, index)" v-for="(item, index) in loginList" :key="index">
              <img class="img_type" v-show="!item.show" :src="item.icon" />
              <img class="img_type" v-show="item.show" :src="item.icon_select" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="选择账号" :visible.sync="listShow" width="30%">
      <div class="account_box">
        <div class="item" v-for="(v, k) in accountList" :key="k">
          <div class="info">
            <img class="headimg" :src="v.head_img ? v.head_img : '@/assets/tabicon44.png'" alt="" srcset="" />
            <div class="acc_promote">
              <div class="acc">{{ v.account }}</div>
              <div class="promote">{{ v.id }}</div>
            </div>
          </div>
          <div class="btn" @click="checkLogin(v)">登录</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="listShow = false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 微信扫码登录 -->
    <el-dialog title="微信扫码登录" :visible.sync="visibleWx" width="500px">
      <div style="display: flex;justify-content: center;height: 400px;">
        <wxlogin appid="wx9b6f18db6eb84206" scope="snsapi_login" theme="'black'"
          :redirect_uri="encodeURIComponent('https://www.39bh.com/bhqudao')" :href="href" rel="external nofollow">
        </wxlogin>
      </div>
    </el-dialog>
    <!-- 注册 -->
    <el-dialog title="加入我们" :visible.sync="visibleRegister" width="500px" :close-on-click-modal="false">
      <div class="re_box">
        <el-form ref="form" :model="form" :inline="true" label-width="80px">
          <el-form-item label="账号" prop="user">
            <el-input v-model="form.user" autocomplete="off" placeholder="账号为6-30位数字,字母或中文字符组合">
              <i slot="prefix" class="el-input__icon el-icon-user"></i>
            </el-input>
          </el-form-item>
          <el-form-item label="类型" prop="type">
            <!-- <i class="el-input__icon el-icon-s-operation"></i> -->
            <el-radio-group v-model="form.type">
              <el-radio :label="0">个人</el-radio>
              <el-radio :label="1">公会</el-radio>
              <el-radio :label="2">公众号</el-radio>
              <el-radio :label="3">其他</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="密码" prop="pwd">
            <el-input v-model="form.pwd" type="password" autocomplete="off" placeholder="密码为6-15位字母、数字或特殊字符组合">
              <i slot="prefix" class="el-input__icon el-icon-lock"></i>
            </el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="conPwd">
            <el-input v-model="form.conPwd" type="password" autocomplete="off" placeholder="请输入确认密码">
              <i slot="prefix" class="el-input__icon el-icon-lock"></i>
            </el-input>
          </el-form-item>
          <el-form-item label="二级密码" prop="twoPwd">
            <el-input v-model="form.twoPwd" type="password" autocomplete="off" placeholder="请输入二级密码">
              <i slot="prefix" class="el-input__icon el-icon-lock"></i>
            </el-input>
          </el-form-item>
          <el-form-item label="邮箱" prop="email">
            <el-input v-model="form.email" autocomplete="off" placeholder="请输入邮箱(非必填项)">
              <i slot="prefix" class="el-input__icon el-icon-message"></i>
            </el-input>
          </el-form-item>
          <el-form-item label="联系人" prop="real_name">
            <el-input v-model="form.real_name" autocomplete="off" placeholder="请输入联系人姓名">
              <i slot="prefix" class="el-input__icon el-icon-coordinate"></i>
            </el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="mobile_phone">
            <el-input v-model="form.mobile_phone" autocomplete="off" placeholder="请输入手机号码">
              <i slot="prefix" class="el-input__icon el-icon-mobile"></i>
            </el-input>
          </el-form-item>
          <el-form-item label="验证码" prop="code">
            <div class="register_code">
              <el-input v-model="form.code" type="number" autocomplete="off" placeholder="请输入验证码">
                <i slot="prefix" class="el-input__icon el-icon-folder-checked"></i>
              </el-input>
              <div @click="getCodeRegister" :class="['code_box', sendOkRegister ? 'send_ok' : '']">
                {{ textRegister }}
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visibleRegister = false">取 消</el-button>
        <el-button type="primary" :loading="loading" @click="confirmRegister">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import {
    login,
    getUser,
    phoneLogin,
    code,
    phoneCheckLogin,
    wxLogin,
    register
  } from "@/api/login";
  import {
    sendSms,
    get_customize_config
  } from "@/api/my";
  import wxlogin from 'vue-wxlogin';
  import {
    mapGetters
  } from "vuex";
  import {
    cashList
  } from "@/utils/menu";
  export default {
    name: "login",
    components: {
      wxlogin
    },
    data() {
      return {
        form: {
          user: '',
          type: 0,
          pwd: '',
          conPwd: '',
          twoPwd: '',
          email: '',
          real_name: '',
          mobile_phone: '',
          code: ''
        },
        loading: false,
        visibleRegister: false,
        timerRegister: null,
        logType: "account",
        account: {
          account: "",
          pwd: ""
        },
        phone: {
          phone: "",
          code: ""
        },
        sendOk: false,
        sendOkRegister: false,
        textRegister: '获取验证码',
        text: "获取验证码",
        timer: null,
        second: 60,
        secondRegister: 60,
        accountList: [],
        listShow: false,
        loginList: [{
            icon: require("@/assets/user.png"),
            icon_select: require("@/assets/user_select.png"),
            show: 1,
            type: "account"
          },
          {
            icon: require("@/assets/phone.png"),
            icon_select: require("@/assets/phone_select.png"),
            show: 0,
            type: "phone"
          },
          {
            icon: require("@/assets/wx.png"),
            icon_select: require("@/assets/wx_select.png"),
            show: 0,
            type: "wx"
          }
        ],
        userList: [],
        checked: false,
        checkList: [],
        visibleWx: false,
        hidePwd: true,
        href: `data:text/css;base64,LmltcG93ZXJCb3ggLnFyY29kZSB7CiAgICBib3JkZXI6IG5vbmU7CiAgICAgd2lkdGg6IDIwMHB4OwogICAgIGhlaWdodDogMjAwcHg7CiAgfQ==`,
        loginImg: require('@/assets/login_bg.png'),
        busier_id: '',
        btnLoading: false
      };
    },
    computed: {
      ...mapGetters(["userInfo"])
    },
    watch: {
      visibleRegister(n, o) {
        if (!n) {
          if (this.timerRegister) {
            clearInterval(this.timerRegister);
            this.sendOkRegister = false;
            this.textRegister = "获取验证码";
            this.secondRegister = 60;
          }
        }
      }

    },
    beforeDestroy() {
      if (this.timer) {
        clearInterval(this.timer);
      }
    },
    created() {
      let userList = JSON.parse(localStorage.getItem("userList"));
      this.userList = userList;
    },
    mounted() {
      let remember = localStorage.getItem('tg_remember')
      // console.log(typeof remember)
      if (remember == 'true') {
        this.account.account = localStorage.getItem('tg_account')
        this.account.pwd = localStorage.getItem('tg_pwd')
        this.checkList = ['记住密码']
      } else {
        this.checkList = []
      }
      let url = window.location.href
      let index = url.indexOf('code')
      if (index >= 0) {
        let code = url.split('code=')[1].split('&')[0]
        if (code) {
          wxLogin({
            login_type: 'wx',
            code: code
          }).then(res => {
            // console.log(res)
            if (res.code == 200) {
              localStorage.setItem("tg_token", res.data.token);
              getUser().then(res2 => {
                if (res2.code == 200) {
                  this.loginSuccess(res2)
                  let endIndex = url.indexOf('?')
                  if (endIndex >= 0) {
                    let initUrl = url.substring(0, endIndex)
                    window.history.replaceState(null, null, initUrl);
                  }
                }

              });
            }
          })
        }
      }
      let registerIndex = url.indexOf('register')
      if (registerIndex > 0) {
        this.visibleRegister = true
      }
      let busier_idIndex = url.indexOf('busier_id')
      if (busier_idIndex > 0) {
        let busier_id = url.split('busier_id=')[1].split('&')[0]
        this.busier_id = busier_id.split('#')[0]
      }

    },
    methods: {
      openRegister() {
        this.visibleRegister = true
        // this.$refs['form'].resetFields()
        if (this.$refs['form'] != undefined) {
          this.$refs['form'].resetFields();
        }
      },
      getCodeRegister() {
        if (this.form.mobile_phone == "") {
          return this.$message({
            message: "请输入手机号",
            type: "warning"
          });
        }
        if (!this.$tools.checkPhone(this.form.mobile_phone)) {
          return this.$message({
            message: "请输入正确手机号",
            type: "warning"
          });
        }
        if (this.sendOkRegister) {
          return;
        }
        sendSms({
          type: 'promote_register',
          mobile_phone: this.form.mobile_phone
        }).then(res => {
          this.$message({
            message: res.msg,
            type: "success"
          });
          this.sendOkRegister = true;
          this.timerRegister = setInterval(() => {
            if (this.secondRegister <= 0) {
              clearInterval(this.timerRegister);
              this.sendOkRegister = false;
              this.textRegister = "获取验证码";
              this.secondRegister = 60;
              return;
            }
            this.sendOkRegister = true;

            --this.secondRegister;
            this.textRegister = `${this.secondRegister}s`;
          }, 1000);
        });
      },
      confirmRegister() {
        if (this.form.user == "") {
          return this.$message({
            message: "请输入账号",
            type: "warning"
          });
        }
        if (this.form.pwd == "") {
          return this.$message({
            message: "请输入密码",
            type: "warning"
          });
        }
        if (this.form.conPwd == "") {
          return this.$message({
            message: "请输入确认密码",
            type: "warning"
          });
        }
        if (this.form.pwd != this.form.conPwd) {
          return this.$message({
            message: "两次密码输入不一致",
            type: "warning"
          });
        }
        if (this.form.twoPwd == "") {
          return this.$message({
            message: "请输入二级密码",
            type: "warning"
          });
        }
        if (this.form.real_name == "") {
          return this.$message({
            message: "请输入联系人姓名",
            type: "warning"
          });
        }
        if (this.form.mobile_phone == "") {
          return this.$message({
            message: "请输入手机号码",
            type: "warning"
          });
        }
        if (this.form.code == "") {
          return this.$message({
            message: "请输入验证码",
            type: "warning"
          });
        }
        this.loading = true
        let params = {
          reaccount: this.form.user,
          register_type: this.form.type,
          regpassword: this.form.pwd,
          regrepassword: this.form.conPwd,
          resecpassword: this.form.twoPwd,
          email: this.form.email,
          real_name: this.form.real_name,
          mobile_phone: this.form.mobile_phone,
          sms: this.form.code,
          busier_id: this.busier_id
        }
        register(params).then(res => {
          this.loading = false
          if (res.code == 200) {

            this.visibleRegister = false
            this.$message({
              message: res.msg,
              type: 'success'
            })
          }
        })
      },
      changeRember(v) {
        if (v.length > 0) {
          localStorage.setItem('tg_remember', true)
        } else {
          localStorage.setItem('tg_remember', false)
        }
      },
      handleClick(tab, event) {
        // console.log(tab, event);
      },
      //选择账号登录
      async checkLogin(v) {
        // console.log(v);
        await phoneCheckLogin({
          phone: v.mobile_phone,
          password: v.password,
          id: v.id
        }).then(res => {
          localStorage.setItem("tg_token", res.data.token);
          this.$message({
            message: res.msg,
            type: "success"
          });
        });
        getUser().then(res => {
          if (res.code == 200) {
            this.loginSuccess(res)
            this.listShow = false;
          }

        });
      },
      //切换登录方式
      changeLogin(v, k) {
        if (k == 2) {
          this.visibleWx = true
          // this.$message({
          //   message: '暂未开放',
          //   type: 'warning'
          // });
          return
        }
        this.loginList.forEach(item => {
          item.show = 0;
        });
        this.logType = v.type;
        this.loginList[k].show = 1;
      },
      getCode() {
        // this.sendOk = true
        if (this.phone.phone == "") {
          return this.$message({
            message: "请输入手机号",
            type: "warning"
          });
        }
        if (!this.$tools.checkPhone(this.phone.phone)) {
          return this.$message({
            message: "请输入正确手机号",
            type: "warning"
          });
        }
        if (this.sendOk) {
          return;
        }
        code({
          phone: this.phone.phone
        }).then(res => {
          this.$message({
            message: res.msg,
            type: "success"
          });
          this.sendOk = true;
          this.timer = setInterval(() => {
            if (this.second <= 0) {
              clearInterval(this.timer);
              this.sendOk = false;
              this.text = "获取验证码";
              this.second = 60;
              return;
            }
            this.sendOk = true;

            --this.second;
            this.text = `${this.second}s`;
          }, 1000);
        });
      },
      addAccount(user, id, pwd) {
        if (this.userList) {
          let isAccount = this.userList.some(v => {
            return v.account == user;
          });
          if (!isAccount) {
            if (this.userList.length < 5) {
              this.userList.push({
                account: user,
                id,
                pwd
              });
              let userList = JSON.stringify(this.userList);
              localStorage.setItem("userList", userList);
            }
          }
        } else {
          let account = [{
            account: user,
            id,
            pwd
          }];
          account = JSON.stringify(account);
          localStorage.setItem("userList", account);
        }
      },
      getConfig() {
        get_customize_config().then(res => {
          if (res.code == 200) {
            if (res.data.pc.union_set) {
              let data = res.data.pc.union_set
              document.title = data.site_name || '推广游戏_合作平台'
              document.querySelector("link[rel*='icon']").href = data.pc_icon ||
                'https://bhres.39bh.com/site/20220114/9425aba3bc76acd8324309797cef8501.png'
              this.$parent.companyName = data.company_name || '冰火游戏'
              this.$parent.webLogo = data.website_logo ||
                'https://bhres.39bh.com/site/20220114/9425aba3bc76acd8324309797cef8501.png'
            } else {
              document.title = '推广游戏_合作平台'
              this.$parent.companyName = '冰火游戏'
              this.$parent.webLogo =
                'https://bhres.39bh.com/site/20220114/9425aba3bc76acd8324309797cef8501.png'
              document.querySelector("link[rel*='icon']").href =
                'https://bhres.39bh.com/site/20220114/9425aba3bc76acd8324309797cef8501.png'
            }
          }
        })
      },
      async login() {
        if (this.logType == "account") {
          if (this.account.account == "") {
            return this.$message({
              message: "请输入账号",
              type: "warning"
            });
          }
          if (this.account.pwd == "") {
            return this.$message({
              message: "请输入密码",
              type: "warning"
            });
          }
          this.btnLoading = true
          let res = await login({
            account: this.account.account,
            password: this.account.pwd
          });
          if (res.code == 200) {
            localStorage.setItem("tg_token", res.data.token);
            this.addAccount(
              res.data.promote_account,
              res.data.id,
              this.account.pwd
            );
            if (this.checkList.length > 0) {
              localStorage.setItem('tg_account', this.account.account)
              localStorage.setItem('tg_pwd', this.account.pwd)
            } else {
              localStorage.removeItem('tg_account')
              localStorage.removeItem('tg_pwd')
            }
            getUser().then(resp => {
              if (resp.code == 200) {
                this.loginSuccess(resp)
              }
            });
          }
          this.btnLoading = false

        }
        if (this.logType == "phone") {
          if (this.phone.phone == "") {
            return this.$message({
              message: "请输入手机号",
              type: "warning"
            });
          }
          if (this.phone.code == "") {
            return this.$message({
              message: "请输入验证码",
              type: "warning"
            });
          }
          this.btnLoading = true
          phoneLogin({
            phone: this.phone.phone,
            code: this.phone.code
          }).then(res => {
            if (res.code == 200) {
              if (res.data.type == 2) {
                this.accountList = res.data.data;
                this.code = "";
                this.listShow = true;
              } else {
                localStorage.setItem("tg_token", res.data.data.token);
                getUser().then(res2 => {
                  if (res2.code == 200) {
                    this.loginSuccess(res2)
                  }
                });
              }
            }
            this.btnLoading = false
          });
        }
      },
      loginSuccess(data) {
        this.$store.dispatch("getUserInfo", data.data);
        localStorage.setItem('USER', JSON.stringify(data.data))
        this.$message({
          message: "登录成功",
          type: "success"
        });
        this.getConfig()
        this.$router.push({
          name: "home",
          query: {
            type: 'login'
          }
        });
      }
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  .hello {
    width: 100vw;
    height: 100vh;
    background-image: require("@/assets/login_bg.png");
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    .login_box {
      width: 1000px;
      height: 500px;
      background-color: white;
      border-radius: 20px;
      display: flex;

      .left {
        width: 550px;
        // background-color: #29d89420;
        border-radius: 20px 0 0 20px;
        display: flex;
        justify-content: center;
        // align-items: center;
        flex-direction: column;

        .name {
          font-weight: bold;
          // margin-bottom: 15px;
        }

        .out_img_box {
          position: relative;
          // width: 140px;
          // height: 140px;
          display: flex;
          align-items: center;
          justify-content: center;

          .left_img {
            // width: 108px;
            // height: 108px;
            // position: absolute;
            // z-index: 9999;
          }
        }

        .spin_box {
          width: 140px;
          height: 140px;
          position: relative;
          border-radius: 50%;
          // animation: rote 10s linear infinite;
          top: 0;
          left: 0;



          .small_img {
            width: 30px;
            height: 30px;
            position: absolute;
            left: 50%;
            transform-origin: 15px 85px;
            transform: rotate(0);
            top: -15px;
            margin-left: -12px;

            &:nth-of-type(2) {
              transform: rotate(45deg);

            }

            &:nth-of-type(3) {
              transform: rotate(90deg);
            }

            &:nth-of-type(4) {
              transform: rotate(135deg);
            }

            &:nth-of-type(5) {
              transform: rotate(180deg);
            }

            &:nth-of-type(6) {

              transform: rotate(225deg);
            }

            &:nth-of-type(7) {

              transform: rotate(270deg);
            }

            &:nth-of-type(8) {

              transform: rotate(315deg);
            }

            @keyframes rote {
              0% {
                transform: rotate(0);

              }

              100% {
                transform: rotate(360deg);

              }
            }
          }
        }
      }

      .right_box {
        width: 350px;
        padding: 0 30px 20px 30px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        margin-left: 50px;

        .right_top {
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-top: 80px;
        }

        .bh_icon {
          width: 190px;
          height: 60px;
          margin-top: 40px;
        }

        .bh_name {
          font-size: 26px;
          color: #051232;
          // margin: 0 auto 20px auto;
          text-align: center;
          font-weight: 700;
        }

        .login_type_box {
          margin-top: 20px;
          width: 330px;
        }

        .rember_box {
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 70px;

          .register {
            font-size: 14px;
            color: #29d894;
            cursor: pointer;
          }
        }

        .put_box {
          display: flex;
          align-items: center;
          border-bottom: 1px solid #dcdfe6;

          .icon {
            color: #29d894;
          }

          /deep/.el-input__inner {
            border: none !important;
          }

          .code_box {
            height: 30px;
            width: 100px;
            background-color: #29d894;
            border-radius: 30px;
            color: white;
            text-align: center;
            line-height: 30px;
            flex-shrink: 0;
            font-size: 14px;
            cursor: pointer;
          }

          .send_ok {
            background-color: #dcdfe6;
          }
        }

        .btn {
          background-color: #29d894;
          height: 40px;
          text-align: center;
          line-height: 40px;
          border-radius: 10px;
          color: white;
          margin-top: 20px;
          cursor: pointer;
          width: 330px;
        }

        .login_type {
          width: 330px;
          // height: 348px;
          display: flex;
          justify-content: center;
          padding: 100rpx 60rpx 0 60rpx;
          border: 1px solid transparent;
          box-sizing: border-box;
          margin-top: 30px;
          justify-content: space-between;
          // .item {
          //   margin-left: 50px;

          //   &:first-child {
          //     margin-left: 0;
          //   }
          // }

          .img_type {
            width: 40px;
            height: 40px;
            cursor: pointer;
          }
        }
      }
    }
  }

  .account_box::-webkit-scrollbar {
    display: none;
  }

  .account_box {
    overflow-y: scroll;
    max-height: 300px;

    .item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 15px;

      &:first-child {
        margin-top: 0;
      }

      .info {
        display: flex;

        .headimg {
          width: 50px;
          height: 50px;
          border-radius: 50%;
        }

        .acc_promote {
          margin-left: 15px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 5px 0;
          box-sizing: border-box;
          height: 50px;

          .acc {
            font-size: 18px;
            font-weight: bolder;
          }

          .promote {
            font-size: 16px;
            color: #767676;
          }
        }
      }

      .btn {
        color: #fff;
        background-color: #29d894;
        font-size: 16px;
        width: 100px;
        height: 40px;
        text-align: center;
        line-height: 40px;
        border-radius: 40px;
        cursor: pointer;
      }
    }
  }

  .register_code {
    display: flex;
    align-items: center;

    .code_box {
      height: 40px;
      width: 100px;
      background-color: #29d894;
      border-radius: 5px;
      color: white;
      text-align: center;
      line-height: 40px;
      flex-shrink: 0;
      font-size: 14px;
      cursor: pointer;
      margin-left: 20px;
    }

    .send_ok {
      background-color: #dcdfe6;
    }

    /deep/ .el-input__inner {
      width: 180px !important;
    }
  }

  .re_box {
    /deep/ .el-input__inner {
      width: 300px;
    }
  }
</style>
<style>
  .impowerBox .qrcode {
    border: none;
    width: 200px;
    height: 200px;
  }
</style>



// WEBPACK FOOTER //
// src/components/login/index.vue